<div class="container mt-3">
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType" [isSmallVersion]="screenSize < 376"></fgb-leaderboard>
</div>
